<template>
    <div>
        <section class="tournaments">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="12" offset-md="2">

                        <template v-if="main || weekly.length > 0">
                            <h2 class="section-subtitle">Aktivní turnaje</h2>

                            <v-row>
                                <tournament-item v-if="main !== undefined" :tournament="main"/>

                                <tournament-item v-for="tournament in weekly" :key="tournament.id" :tournament="tournament"/>
                            </v-row>
                        </template>

                        <template v-if="oncoming.length > 0">
                            <h2 class="section-subtitle">Budoucí turnaje</h2>

                            <v-row>
                                <tournament-item v-for="tournament in oncoming" :key="tournament.id" :tournament="tournament"/>
                            </v-row>
                        </template>

                        <template v-if="past.length > 0">
                            <h2 class="section-subtitle">Uplynulé turnaje</h2>

                            <v-row>
                                <tournament-item v-for="tournament in past" :key="tournament.id" :tournament="tournament"/>
                            </v-row>
                        </template>
                    </v-col>
                </v-row>
            </v-container>
        </section>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import TournamentItem from '../components/Tournament/TournamentItem';
    import { TOURNAMENTS_LIST_REQUEST } from '../store/actions/tournament'

    export default {
        name: 'Tournament',
        components: { TournamentItem },
        computed: {
            ...mapState({
                tournaments: state => state.tournament.tournaments,
            }),
            past () {
                return this.tournaments.filter((tournament) => {
                    const to = new Date(tournament.end.date);
                    to.setHours(23, 59, 59);
                    const now = new Date();
                    return to.getTime() < now.getTime();
                }).sort(this.sortTournaments);
            },
            oncoming () {
                return this.tournaments.filter((tournament) => {
                    const from = new Date(tournament.start.date);
                    const now = new Date();
                    return from.getTime() > now.getTime();
                }).sort(this.sortTournaments);
            },
            active () {
                return this.tournaments.filter((tournament) => {
                    const from = new Date(tournament.start.date);
                    const to = new Date(tournament.end.date);
                    to.setHours(23, 59, 59);
                    const now = new Date();
                    return from.getTime() < now.getTime()
                        && to.getTime() > now.getTime();
                }).sort(this.sortTournaments);
            },
            main () {
                return this.active.find((tournament) => tournament.type === 'main');
            },
            weekly () {
                return this.active.filter((tournament) => tournament.type === 'weekly');
            },
        },
        methods: {
            sortTournaments (a, b) {
                return (new Date(a.start.date)).getTime() - (new Date(b.start.date)).getTime();
            },
        },
        created () {
            this.$store.dispatch('tournament/' + TOURNAMENTS_LIST_REQUEST);
        },
    }
</script>
